import { mapSiteEmployeeTypes } from './../Types/HeyTraderTypes/Attendances/SiteEmployeeType';
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAtendanceExpenseCategory, getAtendanceHomeDataNew, getAttendanceViewDetail, getAttendanceEmployeeListServiceNew, getAttendanceProjectListServiceNew } from "../../Api/NewAttendance/NewAttendanceService";
import { mapExpenses } from '../Types/HeyTraderTypes/Attendances/New/Expense';
import { mapAttendance } from '../Types/HeyTraderTypes/Attendances/New/Attendance';
import { AttendanceHomeSearch } from '../Types/HeyTraderTypes/Attendances/New/AttendanceHomeSearch';
import { mapAttendanceProjectTypes } from '../Types/HeyTraderTypes/Attendances/AttendanceProjectType';
import { AttendanceViewDetailInput, mapAttendanceViewDetail } from '../Types/HeyTraderTypes/Attendances/New/AttendanceViewDetail';
// import { mapAttendanceViewDetail } from '../Types/HeyTraderTypes/Attendances/New/AttendanceStaffView';

// get attendance employee list
export const getAttendanceEmployeeListNew = createAsyncThunk(
  'getAttendanceEmployeeListNew',
  async (date: string | null | undefined, { rejectWithValue }) => {
    try {
      const response = await getAttendanceEmployeeListServiceNew(date);

      if (response.status) {
        return mapSiteEmployeeTypes(response.body);
      } else {
        return rejectWithValue(response.error);
      }
    } catch (error: any) {
      return rejectWithValue('Failed to fetch attendance employee list');
    }
  }
);

// get attendance employee list
export const getAttendanceExpenseList = createAsyncThunk(
  'getAttendanceExpenseList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAtendanceExpenseCategory();

      if (response.status) {
        return mapExpenses(response.body);
      } else {
        return rejectWithValue(response.error);
      }
    } catch (error: any) {
      return rejectWithValue('Failed to fetch attendance expenses list');
    }
  }
);

// get attendance project list
export const getAttendanceProjectNew = createAsyncThunk('getAttendanceProjectNew', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAttendanceProjectListServiceNew();
    if (response.status) {
      return mapAttendanceProjectTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch attendance projets');
  }
});

// get attendance employee list
export const getAttendanceHomeNew = createAsyncThunk(
  'getAttendanceHomeNew',
  async (input: AttendanceHomeSearch, { rejectWithValue }) => {
    try {
      const response = await getAtendanceHomeDataNew(input);

      if (response.status) {
        return mapAttendance(response.body);
      } else {
        return rejectWithValue(response.error);
      }
    } catch (error: any) {
      return rejectWithValue('Failed to fetch attendance data');
    }
  }
);

// fetch attendance view detail
export const fetchAttendanceViewDetail = createAsyncThunk(
  'fetchAttendanceViewDetail',
  async (input: AttendanceViewDetailInput, { rejectWithValue }) => {
    try {
      const response = await getAttendanceViewDetail(input);

      if (response.status) {
        return mapAttendanceViewDetail(response.body);
      } else {
        return rejectWithValue(response.error);
      }
    } catch (error: any) {
      return rejectWithValue('Failed to fetch detail');
    }
  }
);

